import { getToken } from '../../helpers/get-token'
import axiosInstance from '../../axios/instance'

async function exportPeriodAdvertiserPerformance(interval, accountManagerId) {
    try {
        const token = getToken()
        axiosInstance.defaults.headers.common['authorization'] = token
        const url = new URL(`${process.env.REACT_APP_HUB_URL}/api/analytics/advertiser/period/performance/export`)

        const queryParams = {
            interval: interval || 1,
            account_manager_id: accountManagerId
        }

        Object.entries(queryParams).forEach(([key, value]) => {
            if (value) url.searchParams.set(key, value)
        })

        const response = await axiosInstance.get(url.toString(), {
            responseType: 'blob' // Specify that we expect binary data
        })

        // Create a blob from the response data
        const blob = new Blob([response.data], { 
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
        })
        
        // Create a download link
        const downloadUrl = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = downloadUrl
        link.download = `campaign_performance_${new Date().toISOString().split('T')[0]}.xlsx`
        
        // Trigger the download
        document.body.appendChild(link)
        link.click()
        
        // Clean up
        document.body.removeChild(link)
        window.URL.revokeObjectURL(downloadUrl)

        return true
    } catch (error) {
        console.error('Error downloading file:', error)
        throw error
    }
}

export default exportPeriodAdvertiserPerformance
